import Vue from 'vue'
import OrderPopup from './popup'

let PopupTem = Vue.extend(OrderPopup)
let instance
let popup = options => {
  if (!instance) {
    instance = new PopupTem()
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  instance.show = false
  instance.type = options.type
  instance.config = options.config || { orderBase: {}, orderCommodityUnits: [] }
  instance.tempTerminal = options.tempTerminal
  instance.cb = options.cb // 回调

  // 避免弹窗突然出现
  setTimeout(() => {
    instance.show = true
  }, 50)
}
popup.close = () => {
  instance && (instance.show = false)
}
export default popup
